<template>
<div class="chapter">
<div class="inner_page">
<p class="center" style="margin-top:20px;"><a href="http://www.earlybirdbooks.com/?utm_campaign=Early%20Bird%20Books&amp;utm_source=In%20Book%20Ad&amp;utm_medium=Referral&amp;utm_content=front" target="_blank"><img alt="signup" src="images/signup.jpg"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebadfront.vue?6187e6cc